import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import * as actions from './actions'

import exploitations from './modules/exploitations'
import exploitation from './modules/exploitation'
import simulation from './modules/simulation'
import auth from './modules/auth'
import confirm from './modules/confirm'
import alerte from './modules/alerte'
import prompt from './modules/prompt'
import select from './modules/select'
import referentiel from './modules/referentiel'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  messagesLoading: [],
  toasts: [],
  captchaPublicKey: null
}

const store = new Vuex.Store({
  strict: debug,
  state,
  actions,
  mutations,
  modules: {
    exploitations,
    exploitation,
    simulation,
    auth,
    confirm,
    alerte,
    prompt,
    select,
    referentiel
  },
  plugins: [
    createPersistedState({
      key: 'asalee',
      paths: ['auth.token']
    })
  ]
})

if (module.hot) {
  // accept actions and mutations as hot modules
  module.hot.accept([
    './mutations',
    './actions',
    './modules/confirm.js',
    './modules/alerte.js',
    './modules/prompt.js',
    './modules/select.js',
    './modules/auth.js',
    './modules/exploitations.js',
    './modules/exploitation.js',
    './modules/simulation.js',
    './modules/referentiel.js'
  ], () => {
    store.hotUpdate({
      actions: require('./actions').default,
      mutations: require('./mutations').default,
      modules: {
        exploitations: require('./modules/exploitations.js').default,
        exploitation: require('./modules/exploitation.js').default,
        simulation: require('./modules/simulation.js').default,
        auth: require('./modules/auth.js').default,
        confirm: require('./modules/confirm.js').default,
        alerte: require('./modules/alerte.js').default,
        prompt: require('./modules/prompt.js').default,
        select: require('./modules/select.js').default,
        referentiel: require('./modules/referentiel.js').default
      }
    })
  })
}

export default store
